import { API } from '@/api';
import axios from 'axios';

const state = {
};
const getters = {
};
const actions = {
  async getContableList({ commit, State }, {admin, condo, options}) {
    console.debug('ID: %o', condo);
    const sortBy = options.sortBy[0] ? options.sortBy[0] + ',' + (options.sortDesc[0] ? 'desc' : 'asc') : '';
    const queryString = {page: options.page - 1, size: options.itemsPerPage, sort: sortBy};
    console.debug('queryString: %o', queryString);
    const response = await API.get('/cuentasContables/list/' + admin.id + '/' + condo.id, {params: queryString});
    return response.data;
  },
  async addContable({ commit, State }, {datos}) {
    const response = await API.post('/cuentasContables/add/' + datos.admin.id + '/' + datos.condo.id, datos.contable);
    return response.data;
  },
  async addBasics({ commit, State }, {datos}) {
    const response = await API.post('/cuentasContables/addBasics/' + datos.admin.id + '/' + datos.condo.id);
    return response.data;
  },
};
const mutations = {
};

export default {
  actions,
  getters,
  mutations,
  state,
};
